const baseItems = [
    { id: "info", label: "Processing Info" },
    { id: "rating", label: "Rating" },
    { id: "signOff", label: "Sign Off" },
    { id: "images", label: "Images" },
    { id: "summary", label: "Summary" },
];

export const BasicSignoffItems = [
    { id: "rating", label: "Rating" },
    { id: "signOff", label: "Sign Off" },
    { id: "images", label: "Images" },
];

export const CairsItems = [{ id: "graft", label: "Graft" }, ...baseItems];

export const CorneaItems = [
    { id: "general", label: "General" },
    { id: "epithelium", label: "Epithelium" },
    { id: "stroma", label: "Stroma" },
    { id: "descemets", label: "Descemets" },
    { id: "endothelium", label: "Endothelium" },
    ...BasicSignoffItems,
    { id: "summary", label: "Summary" },
];

export const DmekItems = [
    { id: "graft", label: "Graft" },
    { id: "stroma", label: "Stroma" },
    { id: "descemets", label: "Descemets" },
    { id: "endothelium", label: "Endothelium" },
    ...baseItems,
];

export const LenticuleItems = [
    { id: "epithelium", label: "Epithelium" },
    { id: "stroma", label: "Stroma" },
    ...baseItems,
];

export const DsaekItems = [
    { id: "epithelium", label: "Epithelium" },
    { id: "stroma", label: "Stroma" },
    { id: "descemets", label: "Descemets" },
    { id: "endothelium", label: "Endothelium" },
    ...baseItems,
];

export const AlkItems = [{ id: "epithelium", label: "Epithelium" }, { id: "stroma", label: "Stroma" }, ...baseItems];
